export default [
    {
        path: "product/index",
        name: "productIndex",
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/sku"),
    },
    // 客户报价管理
    {
        path: "product/customerprice/list",
        name: "customerpriceList",
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/customerprice/index"),
    },
    {
        path: "product/customerprice/update/:type",
        name: "customerpriceUpdate",
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/customerprice/update"),
    },
]
